import React, { useEffect } from 'react'
//import Typed from 'react-typed';
import {FiLinkedin , FiInstagram , FiGithub, FiTwitter,} from "react-icons/fi"
import {AiOutlineSend , AiOutlineArrowDown} from "react-icons/ai"
import avtar from "../assets/tanmay_avtar.png"
import {LuMouse} from "react-icons/lu"
import { TypeAnimation } from "react-type-animation";
function Home(props) {
     
 
   

  return (
    <div id="Home">
      <div className="relative md:h-[580px]  h-[280px] z-[5]  md:pt-[110px]  pt-[40px] ">
        <div className="   flex flex-row mx-auto items-center justify-evenly max-w-[73rem] font-Poppins scroll-smooth  ">
          <div className="flex  flex-col space-y-7  text-deep">
            <a
              href="https://www.linkedin.com/in/tanmay-kumar-438403222"
              target="_blank"
            >
              <FiLinkedin size={20} />
            </a>
            <a href="https://github.com/tanmay2809" target="_blank">
              <FiGithub size={20} />
            </a>
            <a href="https://www.instagram.com/_.tanmay_28" target="_blank">
              <FiInstagram size={20} />
            </a>
            <a
              href="https://x.com/tanmaykuma66037?t=G2-sb4yIHeLhvx4vUy9UMA&s=08"
              target="_blank"
            >
              <FiTwitter size={20} />
            </a>
          </div>
          <div className="flex flex-col space-y-5">
            <h1 className=" text-5xl font-semibold font-Poppinsb">
              Hi,I'm Tanmay
            </h1>

            <div>
              I am a{" "}
              
              <TypeAnimation
                sequence={["Full-stack", 1000, "Web Developer", 1000]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </div>
            <h4 className=" max-w-[17rem] ">
              Building Software to solve real life problems
            </h4>
            <div className="  flex flex-row  relative ">
              <a href="#ContactMe" className=" transition-all ">
                <button className="red-btn rounded-lg pl-5 ">
                  {" "}
                  Contact Me
                </button>
                <div className=" absolute z-[50]  left-[104px] md:left-[112px] top-[19px]">
                  <AiOutlineSend color="black" className="hover:text-deep " />
                </div>
              </a>
            </div>
          </div>
          <div>
            <div class="user-image -m-l-[40] hidden md:flex ">
              <img src={avtar} alt="" height={150} width={300} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home
